import { ListResponse, LoadingParams } from 'framework/list';
import { useDeliveryApi } from 'infrastructure/api';
import { ComplianceProjectStatus } from './types';

export const PROJECTS_COMPLIANCE_API_PATH = '/compliance';

const useProjectsComplianceService = () => {
  const { sendGetRequest } = useDeliveryApi();

  const search = async (_requestParams: LoadingParams): Promise<ListResponse<ComplianceProjectStatus>> => {
    const response = await sendGetRequest(PROJECTS_COMPLIANCE_API_PATH);

    return response.json();
  };

  return { search };
};

export default useProjectsComplianceService;
